import { render } from "./MapVehicleComponent.vue?vue&type=template&id=00018f5a"
import script from "./MapVehicleComponent.vue?vue&type=script&lang=js"
export * from "./MapVehicleComponent.vue?vue&type=script&lang=js"

import "./MapVehicleComponent.vue?vue&type=style&index=0&id=00018f5a&lang=css"
script.render = render

export default script